module.exports = __webpack_public_path__ + "static/media/canTakeQuestion.2d518b0b.mp3";